import { environment } from '../../enviroments/environment';

type ImageResolverConfig = {
  defaultAlias: string;
  aliases: Record<string, string>;
};

type ImageParams = {
  imgVersion: string;
  firstName: string;
  address: string;
};

const DEFAULT_IMAGE_PATH = '/assets/images/default-1.jpg';

function normalizeAlias(alias: string | null | undefined): string {
  return (alias || '').trim().toLowerCase();
}

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, '');
}

function getImageResolverConfig(): ImageResolverConfig {
  const config = (environment as any).imageResolver as ImageResolverConfig | undefined;
  return config || {
    defaultAlias: 'default',
    aliases: {
      default: 'https://landingimgresizer.azurewebsites.net/'
    }
  };
}

export function resolveImageBaseUrl(alias: string | null | undefined): string {
  const config = getImageResolverConfig();
  const requestedAlias = normalizeAlias(alias);
  const defaultAlias = normalizeAlias(config.defaultAlias);
  const aliases = config.aliases || {};

  if (requestedAlias && aliases[requestedAlias]) {
    return normalizeBaseUrl(aliases[requestedAlias]);
  }

  if (aliases[defaultAlias]) {
    return normalizeBaseUrl(aliases[defaultAlias]);
  }

  return normalizeBaseUrl('https://landingimgresizer.azurewebsites.net/');
}

export function buildDynamicImageUrl(
  params: ImageParams,
  alias?: string | null
): string {
  const baseUrl = resolveImageBaseUrl(alias);
  const encodedAddress = encodeURIComponent(params.address).replace(/%20/g, '+');
  return `${baseUrl}/api/ImgRename?ImgVersion=${params.imgVersion}&FName=${params.firstName}&Address=${encodedAddress}.jpg`;
}

export function resolveOgImageUrl(
  params: Partial<ImageParams>,
  alias: string | null | undefined,
  fallbackOrigin: string
): string {
  if (params.imgVersion && params.firstName && params.address) {
    return buildDynamicImageUrl(
      {
        imgVersion: params.imgVersion,
        firstName: params.firstName,
        address: params.address
      },
      alias
    );
  }

  return `${fallbackOrigin}${DEFAULT_IMAGE_PATH}`;
}
